export const INTERVAL_BEFORE_RETURN_FLOW = 30; // days
